import "antd/lib/result/style";
import _Result from "antd/lib/result";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import "antd/lib/spin/style";
import _Spin from "antd/lib/spin";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from 'react';
import Link from 'next/link';
import { useSelector, useDispatch } from 'react-redux';
import { retry } from 'redux/actions/pipeline';
import { getBackendStatus } from 'redux/selectors';
import NotifyByEmail from './NotifyByEmail';
var Title = _Typography.Title,
  Text = _Typography.Text;
var getStatusType = function getStatusType(backendStatus) {
  var _backendStatus$status;
  switch ((_backendStatus$status = backendStatus.status) === null || _backendStatus$status === void 0 || (_backendStatus$status = _backendStatus$status.pipeline) === null || _backendStatus$status === void 0 ? void 0 : _backendStatus$status.status) {
    case 'RUNNING':
      return 'running';
    case 'FAILED':
      return 'error';
    case 'SUCCEEDED':
      return 'success';
    default:
      return 'toBeRun';
  }
};
var ImmuneOnlyLoadingScreen = function ImmuneOnlyLoadingScreen(props) {
  var experimentId = props.experimentId;
  var dispatch = useDispatch();
  var backendStatus = useSelector(getBackendStatus(experimentId));
  var statusType = getStatusType(backendStatus);
  var dataManagementPath = '/data-management';
  var plotsAndTablesPath = "/experiments/".concat(experimentId, "/plots-and-tables");
  var texts = {
    toBeRun: {
      title: 'Let\'s process your data.',
      subTitle: 'Your data needs to go through a processing step before it can be explored. To begin, go to Insights.',
      image: '/undraw_To_the_stars_qhyy.svg',
      alt: 'A rocket ship ready for take-off.'
    },
    running: {
      title: ' ',
      subTitle: ' ',
      image: '/undraw_Dev_focus_re_6iwt.svg',
      alt: 'A woman working in front of a computer.'
    },
    error: {
      title: 'We\'ve had an issue while processing your data.',
      subTitle: 'You can launch another analysis or try again later.',
      image: '/undraw_Abstract_re_l9xy.svg',
      alt: 'A woman confusedly staring at an abstract drawing.'
    },
    success: {
      title: 'Your data has been processed.',
      subTitle: 'You can now explore your data in the Plots and Tables section.'
    }
  };
  var _texts$statusType = texts[statusType],
    title = _texts$statusType.title,
    subTitle = _texts$statusType.subTitle,
    image = _texts$statusType.image,
    alt = _texts$statusType.alt;
  var relaunchExperiment = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(retry(experimentId));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function relaunchExperiment() {
      return _ref.apply(this, arguments);
    };
  }();
  var renderExtra = function renderExtra() {
    if (statusType === 'success') {
      return __jsx(Link, {
        as: plotsAndTablesPath,
        href: plotsAndTablesPath,
        legacyBehavior: true,
        passHref: true
      }, __jsx(_Button, {
        type: "primary",
        key: "console"
      }, "Go to Plots and Tables"));
    }
    if (statusType === 'toBeRun') {
      return __jsx(Link, {
        as: dataManagementPath,
        href: dataManagementPath,
        legacyBehavior: true,
        passHref: true
      }, __jsx(_Button, {
        type: "primary",
        key: "console"
      }, "Go to Insights"));
    }
    if (statusType === 'error') {
      return __jsx(_Space, {
        size: "large"
      }, __jsx(Link, {
        as: dataManagementPath,
        href: dataManagementPath,
        legacyBehavior: true,
        passHref: true
      }, __jsx(_Button, {
        type: "primary",
        key: "console"
      }, "Launch Another Analysis")), __jsx(_Button, {
        type: "primary",
        key: "console",
        onClick: relaunchExperiment
      }, "Re-launch Current Analysis"));
    }
    return __jsx(_Row, null, __jsx(_Col, {
      span: 8,
      offset: 8
    }, __jsx(_Space, {
      direction: "vertical",
      size: "large",
      align: "center",
      style: {
        width: '100%'
      }
    }, __jsx(_Spin, {
      size: "large"
    }), __jsx(Title, {
      level: 3
    }, "We're processing your data..."), __jsx(Text, {
      type: "secondary"
    }, "You can wait or leave this screen and check again later."), __jsx(NotifyByEmail, {
      experimentId: experimentId
    }))));
  };
  return __jsx(_Result, {
    status: statusType,
    title: title,
    subTitle: subTitle,
    icon: image && __jsx("img", {
      width: 250,
      height: 250,
      alt: alt,
      src: image,
      style: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '50%'
      }
    }),
    extra: renderExtra()
  });
};
export default ImmuneOnlyLoadingScreen;